import ArrayUtils from '../utils/ArrayUtils'
import i18n from '../i18n'

const VacationApproveTypesEnum = Object.freeze({
  '10': i18n.t('ApproveTypes.finalApproval'),
  '9': i18n.t('ApproveTypes.secondDegreeApproval'),
  '8': i18n.t('ApproveTypes.thirdDegreeApproval'),
  '7': i18n.t('ApproveTypes.fourDegreeApproval'),
  '6': i18n.t('ApproveTypes.fiveDegreeApproval'),
  '-1': i18n.t('ApproveTypes.choose'),
})

const VacationApproveTypesArray = function () {
  var list = ArrayUtils.EnumToArray(VacationApproveTypesEnum)
  if (list) {
    list.sort((a, b) => {
      ////console.log(a);
      return (a.Code > b.Code) ? 1 : -1
    })
  }

  return list
}

export default { VacationApproveTypesArray };